import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { articles, categories } from '@/mocks/articles';

export default function Home() {
  const featuredArticles = articles.filter((a) => a.isFeatured);
  const hotArticles = articles.filter((a) => a.isHot);
  const latestArticles = articles.slice(0, 8);

  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: '黑料在线看 - 首页',
          description: '汇聚娱乐圈、网红、明星最新独家内幕与爆料资讯。黑料在线看，海量内容实时更新。',
          url: 'https://heiliaozx.com/',
          isPartOf: { '@type': 'WebSite', name: '黑料在线看', url: 'https://heiliaozx.com' },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Hero Section */}
        <header className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20scene%20with%20abstract%20red%20and%20black%20geometric%20patterns%2C%20smoke%20and%20fog%20effects%2C%20mysterious%20atmosphere%2C%20paparazzi%20camera%20flashes%20in%20the%20distance%2C%20urban%20night%20aesthetic%2C%20intense%20dramatic%20lighting%2C%20entertainment%20industry%20theme%2C%20no%20text%20no%20people&width=1800&height=900&seq=hl-hero-bg&orientation=landscape"
            alt="黑料在线看 - 独家内幕全收录"
            title="黑料在线看 - 独家内幕全收录"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center px-4 w-full max-w-4xl">
              <div className="inline-flex items-center gap-2 bg-primary-500/20 border border-primary-500/30 rounded-full px-4 py-1.5 mb-6">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-fill text-primary-400 text-sm"></i>
                </div>
                <span className="text-primary-300 text-sm font-medium whitespace-nowrap">独家内幕 · 实时更新</span>
              </div>
              <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-foreground-50 mb-5 leading-tight">
                黑料在线看
              </h1>
              <p className="text-foreground-300 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
                汇聚娱乐圈、网红、明星最新独家内幕与爆料资讯。海量内容实时更新，一站式满足你的好奇心，绝不删改，直击真相。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link
                  to="/category/dujia-baoliao"
                  className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full font-medium text-sm transition-colors whitespace-nowrap"
                >
                  查看独家爆料
                </Link>
                <Link
                  to="/category/heliao-shipin"
                  className="bg-background-100/80 hover:bg-background-200 text-foreground-100 px-8 py-3 rounded-full font-medium text-sm transition-colors border border-background-300/50 whitespace-nowrap"
                >
                  黑料视频在线
                </Link>
              </div>
            </div>
          </div>
          {/* Scroll indicator */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
            <span className="text-foreground-500 text-xs">向下滚动</span>
            <div className="w-5 h-5 flex items-center justify-center animate-bounce">
              <i className="ri-arrow-down-line text-foreground-400"></i>
            </div>
          </div>
        </header>

        <main className="max-w-7xl mx-auto px-4 md:px-6">

          {/* Category Navigation */}
          <section className="py-10 md:py-14" aria-label="内容分类导航">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-8 text-center">
              探索分类
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-100 border border-background-200/50 hover:border-primary-500/30 hover:bg-background-200/50 transition-all duration-300"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors">
                    <i className={`${cat.icon} text-primary-400 text-xl`}></i>
                  </div>
                  <span className="font-heading text-sm text-foreground-200 group-hover:text-foreground-50 transition-colors whitespace-nowrap">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </section>

          {/* Featured Articles */}
          <section className="pb-10 md:pb-14" aria-label="精选爆料">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-50">
                精选爆料
              </h2>
              <Link
                to="/category/dujia-baoliao"
                className="flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
              >
                查看更多
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.id} article={article} variant="featured" />
              ))}
            </div>
          </section>

          {/* Hot Now */}
          <section className="pb-10 md:pb-14" aria-label="热门黑料">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-fill text-primary-500 text-xl"></i>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-50">
                热门黑料
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {hotArticles.slice(0, 8).map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </section>

          {/* Latest Updates */}
          <section className="pb-10 md:pb-14" aria-label="最新爆料">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-50">
                最新爆料
              </h2>
              <Link
                to="/category/mingxing-heliao"
                className="flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
              >
                查看全部
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </section>

          {/* CTA Section */}
          <section className="pb-10 md:pb-14">
            <div className="relative rounded-lg overflow-hidden p-8 md:p-12">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20dark%20red%20gradient%20background%20with%20dramatic%20lighting%20effects%2C%20mysterious%20smoke%20texture%2C%20luxurious%20dark%20atmosphere%2C%20bold%20cinematic%20feel%2C%20no%20text%20no%20people%2C%20entertainment%20industry%20vibe&width=1400&height=500&seq=hl-cta-bg&orientation=landscape"
                alt=""
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/60"></div>
              <div className="relative z-10 text-center">
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-4">
                  你有猛料要爆？
                </h2>
                <p className="text-foreground-300 text-sm md:text-base mb-6 max-w-lg mx-auto">
                  如果你是圈内人，掌握独家内幕，欢迎联系我们。你的身份将被严格保密，爆料内容经核实后将第一时间发布。
                </p>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full font-medium text-sm transition-colors whitespace-nowrap"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-send-line"></i>
                  </div>
                  联系我们爆料
                </Link>
              </div>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="pb-10 md:pb-14" aria-label="常见问题">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-8 text-center">
              常见问题
            </h2>
            <div className="max-w-3xl mx-auto space-y-4">
              {[
                {
                  q: '黑料在线看的内容来源是什么？',
                  a: '我们的内容来自多渠道的信息网络，包括圈内人士匿名投稿、公开资料整理、以及专业调查团队的深度挖掘。所有发布内容均经过严格核实，确保信息可靠性。',
                },
                {
                  q: '如何向黑料在线看投稿爆料？',
                  a: '你可以通过关于我们页面的联系方式，或者直接发送邮件到 tips@heiliaozx.com。我们承诺对爆料人身份严格保密，经核实的内容将尽快发布。',
                },
                {
                  q: '黑料在线看的内容更新频率如何？',
                  a: '我们实行7×24小时全天候内容监控和更新机制。重大爆料事件发生后，我们会在第一时间跟进报道，确保你不错过任何重要信息。',
                },
                {
                  q: '网站上的内容是否可信？',
                  a: '我们坚持"绝不删改，直击真相"的原则。每一条发布的内容都经过多轮交叉验证。如有不实信息，我们会在核实后第一时间更正并公开说明。',
                },
              ].map((faq, idx) => (
                <details
                  key={idx}
                  className="group bg-background-100 rounded-lg border border-background-200/50 overflow-hidden"
                >
                  <summary className="flex items-center justify-between cursor-pointer p-5 font-medium text-foreground-100 text-sm md:text-base">
                    {faq.q}
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 ml-2">
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-5 text-foreground-400 text-sm leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </section>
        </main>

        <Footer />

        {/* FAQPage Schema */}
        <SchemaOrg
          type="FAQPage"
          data={{
            mainEntity: [
              {
                '@type': 'Question',
                name: '黑料在线看的内容来源是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们的内容来自多渠道的信息网络，包括圈内人士匿名投稿、公开资料整理、以及专业调查团队的深度挖掘。',
                },
              },
              {
                '@type': 'Question',
                name: '如何向黑料在线看投稿爆料？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '你可以通过关于我们页面的联系方式，或者直接发送邮件到 tips@heiliaozx.com。',
                },
              },
              {
                '@type': 'Question',
                name: '黑料在线看的内容更新频率如何？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们实行7×24小时全天候内容监控和更新机制，重大爆料事件发生后第一时间跟进报道。',
                },
              },
              {
                '@type': 'Question',
                name: '网站上的内容是否可信？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们坚持绝不删改直击真相的原则，每一条发布的内容都经过多轮交叉验证。',
                },
              },
            ],
          }}
        />
      </div>
    </>
  );
}